import SafeDrivingTermsContents from '@di-shared/features/safe-driving-LN/SafeDrivingTermsContents';

export interface SafeDrivingTermsPageProps {
  vin: string;
}

function SafeDrivingTermsPage({vin}: SafeDrivingTermsPageProps) {
  return <SafeDrivingTermsContents vin={vin} />;
}

export default SafeDrivingTermsPage;
